<template>
  <v-container>
    <v-row wrap>
      <v-flex xs2>
        <v-btn
          color="orange"
          text
          large
          @click="$router.push({'name': 'Admin'})"
        >
          < Admin Home
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-center">
        <span class="mr-5 headline pa-2">Data Export</span>


      </v-flex>
      <v-flex xs2>
      </v-flex>
    </v-row>
    <v-card>
      <v-select label="Cohort Selection" outlined v-model="cohortSelection" :items="cohortList"></v-select>
      <v-btn @click="getCohortPracticeHistory(cohorts[cohortSelection])"></v-btn>
      {{result}}
      <v-btn @click="getDeckUsage()">Get Raw Data</v-btn>
      <v-btn @click="groupRawDataByUser()" :disabled="rawData == null">Group by User</v-btn>
      <div v-if="byUserData" v-for="(item, key) in byUserData" :key="key">{{item.uid}}, {{item.count}}</div>

    </v-card>
    <v-card class="mt-5">
      <div>
        Extra Deck Package JSON
      </div>
      <div>
        <v-text-field outlined label="deckIdForDownload" v-model="deckIdForDownload"></v-text-field>
        <v-btn @click="getDeckPackage(deckIdForDownload)">Print Data to Console</v-btn>
      </div>
    </v-card>
    <v-card>
      <p>Deck History</p>
      <v-btn @click="queryDeckHistory()">Query Deck History</v-btn>
      <v-btn @click="getCohort()">Query Cohort</v-btn>
      <v-btn @click="getHistoDecks()">Query Histo Decks</v-btn>

      <div>
        <v-btn :loading="processingJSON" @click="makeJsonDownload()">Make JSON Download</v-btn>
        <a href="">Get JSON</a>
      </div>





    </v-card>
  </v-container>

</template>
<script>
import Cohorts from '@/views/admin/cohorts.js'
import firebase from 'firebase'
import moment from 'moment'
import _ from 'underscore'
export default {
  name: 'DataExport',
  data() {
    return {
      cohorts: Cohorts,
      cohortList: Object.keys(Cohorts),
      cohortSelection: null,
      result: null,
      finalResult: [],
      rawData: null,
      byUserData: null,
      deckIdForDownload: null,
      processingJSON: false,
    }
  },
  methods: {
    test(input) {
      console.log(input)
      input.forEach(item => console.log(item))
    },

    getCohortPracticeHistory(cohortUidArray) {

      cohortUidArray.forEach(uid => {
        let user = {}
        firebase.firestore().collection('learningRecord').doc(uid).collection('deckRecord')
        .get().then(snapshot => {
          snapshot.forEach(doc => {
            user[doc.id] = doc.data()
          })
          this.finalResult.push({
            uid,
            data: user
          })

        }).catch(err => {
          console.log(err)
        })
        console.log(JSON.stringify(this.finalResult))
      })

    },
    getDeckUsage() {
      firebase.firestore().collection('activityLog')
      .where('timestamp', '>', moment().subtract(14, 'days').toDate())
      .get().then(snapshot => {
        let ungrouped = []
        snapshot.forEach(doc => {
          let data = doc.data()
          for (let item in data) {
            let entry = data[item]
            if (item != 'timestamp') {
              entry.forEach(x => {
                let formatedX = x
                formatedX.timestamp = moment(x.timestamp.toDate())
                ungrouped.push(formatedX)
              })
            }
          }
        })
        ungrouped = _.sortBy(ungrouped, 'timestamp')
        this.rawData = ungrouped
      })
    },
    groupRawDataByUser() {
      let group = _.groupBy(this.rawData, 'uid')
      let counts = []
      for (let item in group) {

          counts.push({
            uid: item,
            count: group[item].length
          })


      }
      this.byUserData = counts
    },
    getDeckPackage(deckId) {
      firebase.firestore().collection('deckPackages').doc(deckId).get().then(doc => {
        console.log(JSON.stringify(doc.data()))
      })
    },
    queryDeckHistory() {
      let result = []
      firebase.firestore().collectionGroup('deckRecord').get().then(snapshot => {
        snapshot.forEach(doc => {
          result.push(doc.data())

        })
        console.log(JSON.stringify(result))
      })

    },
    getCohort() {
      let result = []
      firebase.firestore().collection('users')
      .where('cohorts', 'array-contains-any', ['ucd2024']).get().then(snapshot => {
        snapshot.forEach(doc => {
          result.push(doc.id)
        })
        console.log(JSON.stringify(result))
      })

    },
    getHistoDecks() {
      let result = []
      firebase.firestore().collection('decks')
      .where('subject', '==', 'Histology').get().then(snapshot => {
        snapshot.forEach(doc => {
          result.push(doc.id)
        })
        console.log(JSON.stringify(result))
      })
    },
    makeJsonDownload() {
      this.processingJSON = true
      let result = []
      firebase.firestore().collectionGroup('deckRecord').get().then(snapshot => {
        snapshot.forEach(doc => {
          result.push(doc.data())
        })
        let json = JSON.stringify(result)
        let dataURL = `data:application/json,${json}`
        const anchor = document.querySelector("a");
        anchor.setAttribute("download", "export.json");
        anchor.setAttribute("href", dataURL);
        this.processingJSON = false
      })
    }

  }
}
</script>
